module.exports = __webpack_public_path__ + "959a2c3086769ab6ff71015a1f8cab97.png";